import classNames from 'classnames';
import ImageCarousel from './image';
import ProductInfo from '../right/product/ProductInfo';
import Checkpoints from '../checkpoints';

const LeftSection = ({ shouldShowTopBar }: { shouldShowTopBar: boolean }) => (
  <div
    className={classNames(
      'flex w-full flex-col gap-y-4 rounded-md px-5 lg:sticky lg:border lg:p-4',
      {
        'top-28': shouldShowTopBar,
        'top-36': !shouldShowTopBar,
      },
    )}
  >
    {/* Product Info ----- Mobile. `useHeading` makes this the page's only
        <h1>. The desktop title in the pricing box is in the HTML too (just
        hidden below `lg`), so it must not be another <h1>. */}
    <ProductInfo className="lg:hidden" useHeading />
    <ImageCarousel />
    {/* Checkpoints  */}
    <Checkpoints className="mt-4 hidden lg:block" />
  </div>
);

export default LeftSection;
